const yellow = "var(--nes-color-yellow)";
const blue = "var(--nes-color-blue)";
const green = "var(--nes-color-green)";
const red = "var(--nes-color-red)";
const orange = "var(--nes-color-orange)";
const purple = "var(--nes-color-purple)";
const pink = "var(--nes-color-pink)";
const black = "var(--nes-color-black)";
const white = "var(--nes-color-white)";
const colors = {
	"yellow-950": "var(--nes-color-yellow-950)",
	"yellow-900": "var(--nes-color-yellow-900)",
	"yellow-800": "var(--nes-color-yellow-800)",
	"yellow-700": "var(--nes-color-yellow-700)",
	"yellow-600": "var(--nes-color-yellow-600)",
	"yellow-500": "var(--nes-color-yellow-500)",
	yellow: yellow,
	"yellow-300": "var(--nes-color-yellow-300)",
	"yellow-200": "var(--nes-color-yellow-200)",
	"yellow-100": "var(--nes-color-yellow-100)",
	"yellow-50": "var(--nes-color-yellow-50)",
	"blue-950": "var(--nes-color-blue-950)",
	"blue-900": "var(--nes-color-blue-900)",
	blue: blue,
	"blue-700": "var(--nes-color-blue-700)",
	"blue-600": "var(--nes-color-blue-600)",
	"blue-500": "var(--nes-color-blue-500)",
	"blue-400": "var(--nes-color-blue-400)",
	"blue-300": "var(--nes-color-blue-300)",
	"blue-200": "var(--nes-color-blue-200)",
	"blue-100": "var(--nes-color-blue-100)",
	"blue-50": "var(--nes-color-blue-50)",
	"light-blue-950": "var(--nes-color-light-blue-950)",
	"light-blue-900": "var(--nes-color-light-blue-900)",
	"light-blue-800": "var(--nes-color-light-blue-800)",
	"light-blue-700": "var(--nes-color-light-blue-700)",
	"light-blue": "var(--nes-color-light-blue)",
	"light-blue-500": "var(--nes-color-light-blue-500)",
	"light-blue-400": "var(--nes-color-light-blue-400)",
	"light-blue-300": "var(--nes-color-light-blue-300)",
	"light-blue-200": "var(--nes-color-light-blue-200)",
	"light-blue-100": "var(--nes-color-light-blue-100)",
	"light-blue-50": "var(--nes-color-light-blue-50)",
	"green-950": "var(--nes-color-green-950)",
	"green-900": "var(--nes-color-green-900)",
	"green-800": "var(--nes-color-green-800)",
	"green-700": "var(--nes-color-green-700)",
	"green-600": "var(--nes-color-green-600)",
	green: green,
	"green-400": "var(--nes-color-green-400)",
	"green-300": "var(--nes-color-green-300)",
	"green-200": "var(--nes-color-green-200)",
	"green-100": "var(--nes-color-green-100)",
	"green-50": "var(--nes-color-green-50)",
	"red-950": "var(--nes-color-red-950)",
	"red-900": "var(--nes-color-red-900)",
	"red-800": "var(--nes-color-red-800)",
	"red-700": "var(--nes-color-red-700)",
	"red-600": "var(--nes-color-red-600)",
	red: red,
	"red-400": "var(--nes-color-red-400)",
	"red-300": "var(--nes-color-red-300)",
	"red-200": "var(--nes-color-red-200)",
	"red-100": "var(--nes-color-red-100)",
	"red-50": "var(--nes-color-red-50)",
	"orange-950": "var(--nes-color-orange-950)",
	"orange-900": "var(--nes-color-orange-900)",
	"orange-800": "var(--nes-color-orange-800)",
	"orange-700": "var(--nes-color-orange-700)",
	"orange-600": "var(--nes-color-orange-600)",
	orange: orange,
	"orange-400": "var(--nes-color-orange-400)",
	"orange-300": "var(--nes-color-orange-300)",
	"orange-200": "var(--nes-color-orange-200)",
	"orange-100": "var(--nes-color-orange-100)",
	"orange-50": "var(--nes-color-orange-50)",
	"purple-950": "var(--nes-color-purple-950)",
	"purple-900": "var(--nes-color-purple-900)",
	"purple-800": "var(--nes-color-purple-800)",
	"purple-700": "var(--nes-color-purple-700)",
	purple: purple,
	"purple-500": "var(--nes-color-purple-500)",
	"purple-400": "var(--nes-color-purple-400)",
	"purple-300": "var(--nes-color-purple-300)",
	"purple-200": "var(--nes-color-purple-200)",
	"purple-100": "var(--nes-color-purple-100)",
	"purple-50": "var(--nes-color-purple-50)",
	"pink-950": "var(--nes-color-pink-950)",
	"pink-900": "var(--nes-color-pink-900)",
	"pink-800": "var(--nes-color-pink-800)",
	"pink-700": "var(--nes-color-pink-700)",
	pink: pink,
	"pink-500": "var(--nes-color-pink-500)",
	"pink-400": "var(--nes-color-pink-400)",
	"pink-300": "var(--nes-color-pink-300)",
	"pink-200": "var(--nes-color-pink-200)",
	"pink-100": "var(--nes-color-pink-100)",
	"pink-50": "var(--nes-color-pink-50)",
	black: black,
	"gray-950": "var(--nes-color-gray-950)",
	"gray-900": "var(--nes-color-gray-900)",
	"gray-800": "var(--nes-color-gray-800)",
	"gray-700": "var(--nes-color-gray-700)",
	"gray-600": "var(--nes-color-gray-600)",
	"gray-500": "var(--nes-color-gray-500)",
	"gray-400": "var(--nes-color-gray-400)",
	"gray-300": "var(--nes-color-gray-300)",
	"gray-200": "var(--nes-color-gray-200)",
	"gray-100": "var(--nes-color-gray-100)",
	"gray-75": "var(--nes-color-gray-75)",
	"gray-50": "var(--nes-color-gray-50)",
	"gray-25": "var(--nes-color-gray-25)",
	white: white,
	"text-default": "var(--nes-color-text-default)",
	"text-heading": "var(--nes-color-text-heading)",
	"text-body": "var(--nes-color-text-body)",
	"text-subtle": "var(--nes-color-text-subtle)",
	"text-ghost": "var(--nes-color-text-ghost)",
	"text-alpha": "var(--nes-color-text-alpha)",
	"text-light": "var(--nes-color-text-light)",
	"text-brand-primary": "var(--nes-color-text-brand-primary)",
	"text-brand-secondary": "var(--nes-color-text-brand-secondary)",
	"text-brand-secondary-strong": "var(--nes-color-text-brand-secondary-strong)",
	"text-brand-ns-go": "var(--nes-color-text-brand-ns-go)",
	"text-info": "var(--nes-color-text-info)",
	"text-info-contrast": "var(--nes-color-text-info-contrast)",
	"text-info-strong": "var(--nes-color-text-info-strong)",
	"text-success": "var(--nes-color-text-success)",
	"text-success-contrast": "var(--nes-color-text-success-contrast)",
	"text-success-strong": "var(--nes-color-text-success-strong)",
	"text-warning": "var(--nes-color-text-warning)",
	"text-warning-contrast": "var(--nes-color-text-warning-contrast)",
	"text-warning-strong": "var(--nes-color-text-warning-strong)",
	"text-alert": "var(--nes-color-text-alert)",
	"text-alert-contrast": "var(--nes-color-text-alert-contrast)",
	"text-alert-strong": "var(--nes-color-text-alert-strong)",
	"text-highlight": "var(--nes-color-text-highlight)",
	"text-highlight-contrast": "var(--nes-color-text-highlight-contrast)",
	"text-highlight-strong": "var(--nes-color-text-highlight-strong)",
	"text-cta-default": "var(--nes-color-text-cta-default)",
	"text-cta-pressed": "var(--nes-color-text-cta-pressed)",
	"text-cta-visited": "var(--nes-color-text-cta-visited)",
	"text-cta-light": "var(--nes-color-text-cta-light)",
	"bg-default": "var(--nes-color-bg-default)",
	"bg-elevated": "var(--nes-color-bg-elevated)",
	"bg-elevated-pressed": "var(--nes-color-bg-elevated-pressed)",
	"bg-elevated-alt": "var(--nes-color-bg-elevated-alt)",
	"bg-elevated-transparent": "var(--nes-color-bg-elevated-transparent)",
	"bg-tint-primary-pale": "var(--nes-color-bg-tint-primary-pale)",
	"bg-tint-primary": "var(--nes-color-bg-tint-primary)",
	"bg-tint-primary-medium": "var(--nes-color-bg-tint-primary-medium)",
	"bg-tint-primary-strong": "var(--nes-color-bg-tint-primary-strong)",
	"bg-tint-secondary": "var(--nes-color-bg-tint-secondary)",
	"bg-tint-secondary-accent": "var(--nes-color-bg-tint-secondary-accent)",
	"bg-tint-info": "var(--nes-color-bg-tint-info)",
	"bg-tint-success": "var(--nes-color-bg-tint-success)",
	"bg-tint-offer": "var(--nes-color-bg-tint-offer)",
	"bg-tint-warning": "var(--nes-color-bg-tint-warning)",
	"bg-tint-alert": "var(--nes-color-bg-tint-alert)",
	"bg-tint-highlight": "var(--nes-color-bg-tint-highlight)",
	"bg-alpha-pale": "var(--nes-color-bg-alpha-pale)",
	"bg-alpha-subtle": "var(--nes-color-bg-alpha-subtle)",
	"bg-alpha-medium": "var(--nes-color-bg-alpha-medium)",
	"bg-alpha-strong": "var(--nes-color-bg-alpha-strong)",
	"bg-brand-primary": "var(--nes-color-bg-brand-primary)",
	"bg-brand-primary-alt": "var(--nes-color-bg-brand-primary-alt)",
	"bg-brand-secondary": "var(--nes-color-bg-brand-secondary)",
	"bg-brand-secondary-strong": "var(--nes-color-bg-brand-secondary-strong)",
	"bg-brand-ns-go": "var(--nes-color-bg-brand-ns-go)",
	"bg-info": "var(--nes-color-bg-info)",
	"bg-success": "var(--nes-color-bg-success)",
	"bg-success-contrast": "var(--nes-color-bg-success-contrast)",
	"bg-warning": "var(--nes-color-bg-warning)",
	"bg-warning-contrast": "var(--nes-color-bg-warning-contrast)",
	"bg-alert": "var(--nes-color-bg-alert)",
	"bg-alert-contrast": "var(--nes-color-bg-alert-contrast)",
	"bg-highlight": "var(--nes-color-bg-highlight)",
	"bg-highlight-contrast": "var(--nes-color-bg-highlight-contrast)",
	"bg-cta-default": "var(--nes-color-bg-cta-default)",
	"bg-cta-pressed": "var(--nes-color-bg-cta-pressed)",
	"border-default": "var(--nes-color-border-default)",
	"border-default-alt": "var(--nes-color-border-default-alt)",
	"border-subtle": "var(--nes-color-border-subtle)",
	"border-light": "var(--nes-color-border-light)",
	"border-strong": "var(--nes-color-border-strong)",
	"border-alpha": "var(--nes-color-border-alpha)",
	"border-alpha-alt": "var(--nes-color-border-alpha-alt)",
	"border-alpha-subtle": "var(--nes-color-border-alpha-subtle)",
	"border-brand-primary": "var(--nes-color-border-brand-primary)",
	"border-brand-secondary": "var(--nes-color-border-brand-secondary)",
	"border-brand-secondary-strong": "var(--nes-color-border-brand-secondary-strong)",
	"border-brand-ns-go": "var(--nes-color-border-brand-ns-go)",
	"border-info": "var(--nes-color-border-info)",
	"border-success": "var(--nes-color-border-success)",
	"border-warning": "var(--nes-color-border-warning)",
	"border-alert": "var(--nes-color-border-alert)",
	"form-label": "var(--nes-color-form-label)",
	"form-bg": "var(--nes-color-form-bg)",
	"form-val": "var(--nes-color-form-val)",
	"form-val-checked": "var(--nes-color-form-val-checked)",
	"form-placeholder": "var(--nes-color-form-placeholder)",
	"form-helptext": "var(--nes-color-form-helptext)",
	"form-checked": "var(--nes-color-form-checked)",
	"form-border": "var(--nes-color-form-border)",
	"form-border-pressed": "var(--nes-color-form-border-pressed)",
	"form-error": "var(--nes-color-form-error)",
	"form-icon": "var(--nes-color-form-icon)",
	"destructive-default": "var(--nes-color-destructive-default)",
	"destructive-pressed": "var(--nes-color-destructive-pressed)",
	"focus-default": "var(--nes-color-focus-default)",
	"focus-pressed": "var(--nes-color-focus-pressed)",
	"focus-light": "var(--nes-color-focus-light)",
	"button-brand-text": "var(--nes-color-button-brand-text)",
	"button-brand-bg": "var(--nes-color-button-brand-bg)",
	"button-brand-bg-pressed": "var(--nes-color-button-brand-bg-pressed)",
	"button-brand-focus": "var(--nes-color-button-brand-focus)",
	"button-primary-text": "var(--nes-color-button-primary-text)",
	"button-primary-bg": "var(--nes-color-button-primary-bg)",
	"button-primary-bg-pressed": "var(--nes-color-button-primary-bg-pressed)",
	"button-primary-inverted-text": "var(--nes-color-button-primary-inverted-text)",
	"button-primary-inverted-bg": "var(--nes-color-button-primary-inverted-bg)",
	"button-primary-inverted-bg-pressed": "var(--nes-color-button-primary-inverted-bg-pressed)",
	"button-secondary-text": "var(--nes-color-button-secondary-text)",
	"button-secondary-bg": "var(--nes-color-button-secondary-bg)",
	"button-secondary-bg-pressed": "var(--nes-color-button-secondary-bg-pressed)",
	"button-secondary-inverted-text": "var(--nes-color-button-secondary-inverted-text)",
	"button-secondary-inverted-bg": "var(--nes-color-button-secondary-inverted-bg)",
	"button-secondary-inverted-bg-pressed": "var(--nes-color-button-secondary-inverted-bg-pressed)",
	"button-tertiary-text": "var(--nes-color-button-tertiary-text)",
	"button-tertiary-text-pressed": "var(--nes-color-button-tertiary-text-pressed)",
	"button-tertiary-bg-pressed": "var(--nes-color-button-tertiary-bg-pressed)",
	"button-tertiary-inverted-text": "var(--nes-color-button-tertiary-inverted-text)",
	"button-tertiary-inverted-bg-pressed": "var(--nes-color-button-tertiary-inverted-bg-pressed)",
	"radio-panel-bg": "var(--nes-color-radio-panel-bg)",
	"radio-panel-bg-checked": "var(--nes-color-radio-panel-bg-checked)",
	"sticker-default-text": "var(--nes-color-sticker-default-text)",
	"sticker-default-border": "var(--nes-color-sticker-default-border)",
	"sticker-default-filled-text": "var(--nes-color-sticker-default-filled-text)",
	"sticker-default-filled-bg": "var(--nes-color-sticker-default-filled-bg)",
	"sticker-brand-text": "var(--nes-color-sticker-brand-text)",
	"sticker-brand-border": "var(--nes-color-sticker-brand-border)",
	"sticker-brand-filled-text": "var(--nes-color-sticker-brand-filled-text)",
	"sticker-brand-filled-bg": "var(--nes-color-sticker-brand-filled-bg)",
	"sticker-subtle-text": "var(--nes-color-sticker-subtle-text)",
	"sticker-subtle-border": "var(--nes-color-sticker-subtle-border)",
	"sticker-subtle-filled-text": "var(--nes-color-sticker-subtle-filled-text)",
	"sticker-subtle-filled-bg": "var(--nes-color-sticker-subtle-filled-bg)",
	"sticker-highlight-text": "var(--nes-color-sticker-highlight-text)",
	"sticker-highlight-bg": "var(--nes-color-sticker-highlight-bg)",
	"sticker-highlight-filled-text": "var(--nes-color-sticker-highlight-filled-text)",
	"sticker-highlight-filled-bg": "var(--nes-color-sticker-highlight-filled-bg)",
	"sticker-offer-text": "var(--nes-color-sticker-offer-text)",
	"sticker-offer-bg": "var(--nes-color-sticker-offer-bg)",
	"sticker-offer-filled-text": "var(--nes-color-sticker-offer-filled-text)",
	"sticker-offer-filled-bg": "var(--nes-color-sticker-offer-filled-bg)",
	"toggle-bg": "var(--nes-color-toggle-bg)",
	"toggle-knob-bg": "var(--nes-color-toggle-knob-bg)",
	"hero-text-dark": "var(--nes-color-hero-text-dark)",
	"hero-text-shadow-light": "var(--nes-color-hero-text-shadow-light)",
	"hero-flow-light": "var(--nes-color-hero-flow-light)",
	"hero-flow-dark": "var(--nes-color-hero-flow-dark)",
	"message-text": "var(--nes-color-message-text)",
	"message-inline-border": "var(--nes-color-message-inline-border)",
	"message-toast-bg": "var(--nes-color-message-toast-bg)",
	"message-toast-error-bg": "var(--nes-color-message-toast-error-bg)",
	"badge-default-bg": "var(--nes-color-badge-default-bg)",
	"badge-default-text": "var(--nes-color-badge-default-text)",
	"badge-brand-bg": "var(--nes-color-badge-brand-bg)",
	"badge-brand-text": "var(--nes-color-badge-brand-text)",
	"badge-alert-bg": "var(--nes-color-badge-alert-bg)",
	"badge-alert-text": "var(--nes-color-badge-alert-text)",
	"badge-subtle-bg": "var(--nes-color-badge-subtle-bg)",
	"badge-subtle-text": "var(--nes-color-badge-subtle-text)",
	"badge-subtle-inverted-bg": "var(--nes-color-badge-subtle-inverted-bg)",
	"badge-subtle-inverted-text": "var(--nes-color-badge-subtle-inverted-text)",
	"badge-success-bg": "var(--nes-color-badge-success-bg)",
	"badge-success-text": "var(--nes-color-badge-success-text)",
	"tooltip-bg": "var(--nes-color-tooltip-bg)",
	"tooltip-text": "var(--nes-color-tooltip-text)",
	"chipcard-input-border-pressed": "var(--nes-color-chipcard-input-border-pressed)",
	"list-item-icon": "var(--nes-color-list-item-icon)",
	"logo-default": "var(--nes-color-logo-default)",
	"logo-light": "var(--nes-color-logo-light)",
	"expandable-text": "var(--nes-color-expandable-text)",
	"expandable-text-pressed": "var(--nes-color-expandable-text-pressed)",
	"expandable-border": "var(--nes-color-expandable-border)",
	"expandable-inverted-text": "var(--nes-color-expandable-inverted-text)",
	"expandable-inverted-text-pressed": "var(--nes-color-expandable-inverted-text-pressed)",
	"expandable-inverted-border": "var(--nes-color-expandable-inverted-border)",
	"feature-tip-bg": "var(--nes-color-feature-tip-bg)",
	"text-list-item-primary": "var(--nes-color-text-list-item-primary)",
	"bottom-sheet-bg": "var(--nes-color-bottom-sheet-bg)",
	"highlight-box-default-bg": "var(--nes-color-highlight-box-default-bg)",
	"highlight-box-default-text": "var(--nes-color-highlight-box-default-text)",
	"highlight-box-offer-bg": "var(--nes-color-highlight-box-offer-bg)",
	"highlight-box-offer-text": "var(--nes-color-highlight-box-offer-text)",
	"highlight-box-info-bg": "var(--nes-color-highlight-box-info-bg)",
	"highlight-box-info-text": "var(--nes-color-highlight-box-info-text)",
	"highlight-box-brand-bg": "var(--nes-color-highlight-box-brand-bg)",
	"highlight-box-brand-text": "var(--nes-color-highlight-box-brand-text)",
	"range-slider-bg": "var(--nes-color-range-slider-bg)",
	"range-slider-bg-pressed": "var(--nes-color-range-slider-bg-pressed)",
	"range-slider-fill": "var(--nes-color-range-slider-fill)",
	"range-slider-minmax": "var(--nes-color-range-slider-minmax)",
	"range-slider-knob-bg": "var(--nes-color-range-slider-knob-bg)",
	"range-slider-knob-border": "var(--nes-color-range-slider-knob-border)",
	"range-slider-knob-border-pressed": "var(--nes-color-range-slider-knob-border-pressed)",
	"alpha-white-0": "var(--nes-alpha-white-0)",
	"alpha-white-50": "var(--nes-alpha-white-50)",
	"alpha-white-75": "var(--nes-alpha-white-75)",
	"alpha-white-100": "var(--nes-alpha-white-100)",
	"alpha-white-200": "var(--nes-alpha-white-200)",
	"alpha-white-500": "var(--nes-alpha-white-500)",
	"alpha-black-25": "var(--nes-alpha-black-25)",
	"alpha-black-50": "var(--nes-alpha-black-50)",
	"alpha-black-75": "var(--nes-alpha-black-75)",
	"alpha-black-100": "var(--nes-alpha-black-100)",
	"alpha-black-200": "var(--nes-alpha-black-200)",
	"alpha-black-300": "var(--nes-alpha-black-300)",
	"alpha-black-400": "var(--nes-alpha-black-400)",
	"alpha-black-500": "var(--nes-alpha-black-500)"
};

const COLORS = Object.assign(Object.assign({}, colors), { inherit: 'inherit' });

export { COLORS as C };
